/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Updated_ColInputs */

const en_settings_tickets_updated_col = /** @type {(inputs: Settings_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated`)
};

/**
* | output |
* | --- |
* | "Last Updated" |
*
* @param {Settings_Tickets_Updated_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_updated_col = /** @type {((inputs?: Settings_Tickets_Updated_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Updated_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_updated_col(inputs)
});
export { settings_tickets_updated_col as "settings.tickets.updated_col" }